import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['EnabledFlexCredentials', 'FlexCredentialByType']
});

const flexProfessionalCredentialsApi = apiWithTags.injectEndpoints({
	tagTypes: ['EnabledFlexCredentials', 'FlexCredentialByType'],
	endpoints: (build) => ({
		enabledFlexCredentials: build.query({
			query: ({ managementCompanyId, caregiverId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: (result, error, arg) => [{ type: 'EnabledFlexCredentials', id: arg.caregiverId }]
		}),
		flexCredentialByType: build.query({
			query: ({ caregiverId, credType, managementCompanyId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credType}`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: (result, error, arg) => [{ type: 'FlexCredentialByType', id: arg.credType }]
		}),
		uploadFlexCredential: build.mutation({
			query: ({ caregiverId, credType, managementCompanyId, formData }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credType}`,
				method: 'POST',
				headers: { 'Content-Type': undefined, 'management-company-id': managementCompanyId },
				body: formData
			}),
			invalidatesTags: (result, error, arg) =>
				error
					? []
					: [
							{ type: 'FlexCredentialByType', id: arg.credType },
							{ type: 'EnabledFlexCredentials', id: arg.caregiverId }
					  ]
		}),
		editFlexCredential: build.mutation({
			query: ({ caregiverId, credentialId, credType, managementCompanyId, formData }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credType}/${credentialId}`,
				method: 'PUT',
				headers: { 'Content-Type': undefined, 'management-company-id': managementCompanyId },
				body: formData
			}),
			invalidatesTags: (result, error, arg) =>
				error
					? []
					: [
							{ type: 'FlexCredentialByType', id: arg.credType },
							{ type: 'EnabledFlexCredentials', id: arg.caregiverId }
					  ]
		}),
		deleteFlexCredential: build.mutation({
			query: ({ caregiverId, credentialId, credentialType, managementCompanyId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credentialType}/${credentialId}`,
				method: 'DELETE',
				headers: { 'management-company-id': managementCompanyId }
			}),
			invalidatesTags: (result, error, arg) => {
				if (!error || error?.data?.errors?.[0]?.reason === 'CREDENTIAL_NOT_FOUND') {
					return [
						{ type: 'FlexCredentialByType', id: arg.credentialType },
						{ type: 'EnabledFlexCredentials', id: arg.caregiverId }
					];
				}

				return [];
			}
		})
	})
});

export const {
	useEnabledFlexCredentialsQuery,
	useFlexCredentialByTypeQuery,
	useUploadFlexCredentialMutation,
	useEditFlexCredentialMutation,
	useDeleteFlexCredentialMutation
} = flexProfessionalCredentialsApi;
